import { useObservable } from 'react-use-observable';

import eduzzAccountsService from 'v2/services/eduzzAccount';

export default function useGetPermissions() {
  const [permissions] = useObservable(() => eduzzAccountsService.getPermissions(), []);

  return permissions;
}
